<template lang="pug">
  Auth(@loginFailed="loginFailed")
    Header
    NowLoading(:show="showNowLoading")
    FloatActionButton
    div.wrap-avatar
      ModuleAvatar(@hideNowLoading="hideNowLoading")

</template>

<style lang="scss" scoped>
.wrap-avatar {
  width: 100%;
  min-height: 100vh;
  padding-top: 48px;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
import FloatActionButton from '@/components/common/FloatActionButton'
import Auth from '@/components/auth'
import Header from '@/components/common/Header'
import NowLoading from '@/components/common/NowLoading'
import ModuleAvatar from '@/components/module/ModuleAvatar'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')

export default {
  components: {
    Auth,
    NowLoading,
    Header,
    FloatActionButton,
    ModuleAvatar
  },
  computed: {
    ...mapStateAuth(['uid', 'isAnonymous'])
  },
  data () {
    return {
      showNowLoading: true
    }
  },
  methods: {
    ...mapActionsAuth(['signOut', 'signInAnonymously']),
    logout () {
      this.signOut()
      setTimeout(() => {
        this.$router.push('/sign-in')
      }, 400)
    },
    async loginFailed () {
      await this.signInAnonymously()
    },
    hideNowLoading () {
      this.showNowLoading = false
    }
  }
}
</script>
